import emailSignatureSaga from './sagas'
import slice from './reducer'

export const {
  fetchRequest: fetchEmailSignatureRequest,
  fetchSuccess: fetchEmailSignatureSuccess,
  fetchError: fetchEmailSignatureError,
  editSuccess: editEmailSignatureSuccess,
  editRequested: editEmailSignatureRequested,
  editError: editEmailSignatureError,
} = slice.actions

export default slice.reducer
export { emailSignatureSaga }
